import src from "IMAGE";
export default { src, width: 458, height: 83, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAI0lEQVR42mMQEhIyBmFRUVFjQUFBY25ubmMBAQFjfn5+MAYAM3gDIqdQZb8AAAAASUVORK5CYII="};
